import { useState, useRef, useEffect } from 'react';
import "../styles/imagezoom.css";

const ImageHoverPopup = ({ imageSrc, altText, height, label }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const imgRef = useRef(null);
  const popupRef = useRef(null);

  const handleMouseEnter = () => {
    if (imgRef.current) {
      const rect = imgRef.current.getBoundingClientRect();
      const padding = 10;
      const popupEl = popupRef.current;

      // Temporarily show popup off-screen to measure it
      setIsHovered(true);

      // Wait for DOM to update and popup to render
      requestAnimationFrame(() => {
        const popupRect = popupEl?.getBoundingClientRect();
        const popupHeight = popupRect?.height || 300;
        const popupWidth = popupRect?.width || 300;

        let top = rect.bottom + padding;
        let left = rect.left;

        if (rect.bottom + popupHeight > window.innerHeight) {
          top = rect.top - popupHeight - padding;
        }

        if (left + popupWidth > window.innerWidth) {
          left = window.innerWidth - popupWidth - padding;
        }

        left = Math.max(padding, left) + 50;

        setPosition({ top, left });
      });
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <div className="image-container">
        {imageSrc && (
          <img
            ref={imgRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className="p-0 m-0 thumbnail-image"
            src={imageSrc}
            alt={altText}
            height={height}
          />
        )}
      </div>

      {isHovered && (
        <div
          ref={popupRef}
          className="popup rounded"
          style={{
            top: position.top,
            left: position.left,
            position: "fixed",
            zIndex: 9999,
          }}
          onMouseLeave={handleMouseLeave}
        >
          <div className="alert bg-label-primary d-flex rounded-0 rounded-top" role="alert">
            <span className="fw-bold fs-6">{label}</span>
          </div>
          <img
            src={imageSrc}
            alt={altText}
            className="larger-image"
          />
        </div>
      )}
    </>
  );
};

export default ImageHoverPopup;
